export default "__VITE_ASSET__3aBhFwJ$__"